import React from 'react';
import { Button } from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';

const LikeButton = ({ isLiked, onClickCallback }) => {

  return (
    <Button 
      variant={isLiked ? 'contained' : 'outlined'} 
      color={'primary'} 
      startIcon={<ThumbUpIcon />}
      onClick={onClickCallback}
    >
      {isLiked ? 'In favorites' : 'Add to favorites'}
    </Button>
  );
};

export default LikeButton;
